export default {
  SettingOrderSourceStrategyParcel: {
    title: 'Single Item Delivery',
    rule: 'Add Rule',
    condition: 'Exclude Conditions',
    pack: 'Package rule delivery settings',
    hint1: 'Enter the quantity to divide by the specified quantity of SKU.',
    hint2: 'If the quantity is not entered and unlimited, it will be divided by the SKU dimension without restrictions.',
    unlimited: 'Unlimited',
    all: 'All',
    batchDeletion: 'Batch Delete',
    rejectText: 'The number of subcontracts cannot be 0, please re-enter',
    confirmText1: 'After saving, orders that have already matched the package rule will not be affected, while orders that have not been matched will be split according to the new package rule. Are you sure you want to save?',
    confirmText2: 'You are bulk deleting',
    confirmText3: 'parcel rules',
    confirmText4: 'package rules for',

    table: {
      commodity: 'Product Code',
      commodityName: 'Product Name',
      skuCoding: 'SKU',
      skuName: 'SKU Name',
      subcontract: 'Package Quantity',
    },

    dialogForm: {
      title: 'Exclude Conditions',
      condition: 'Intercept the sourcing order that meets this quantity and process it when the sourcing fails.',
      formName: 'Quantity of single SKU sourcing',
      rulesValue: 'Please enter a quantity.',
    },

    sendOut: {
      name: 'Product Name',
      subcontract: 'Package Quantity',
      title: 'Select Product',
      commodity: 'Product Code',
      commodityPlaceholder: 'Please enter product code',
      namePlaceholder: 'Please enter product name',
      renderHeader: 'Set the quantity to divide by the specified quantity. If the quantity is not set, it will be divided by the specified product without restriction.',
      empty: 'Clear',
      out2Title: 'Title',
    },

    setMealSeparate: {
      chooseCombo: 'Select Package',
      combo: 'Package',
      comboCode: 'Package Code',
      comboName: 'Package Name',
      subcontract: 'Package Details',
      commodityCode: 'Product Code',
      commodityName: 'Product Name',
      packageNumber: 'Quantity within the package',
      subcontractNumber: 'Package Quantity'
    }
  }
};
